export const EMPTY_OBJ = {}
export const POPUP_PORTAL_ID = 'popupPortal'
export const CHART_LABELS_TILT_THRESHOLD = 30 // px

export const EM_DASH = '\u2014'

export const PAGE_SIZE_OPTIONS = [5, 20, 40]
export const QA_MARKER_PROP = 'qaMarker'
export const QA_MARKER_OVERLAY_CLOSE_BUTTON = 'overlay-close-button'

export const GUARD_LOADING_TIMEOUT = 8000

export const SHOW_SIDEBAR_POPUP_MOUSE_TIMEOUT_SHORT = 100
export const SHOW_SIDEBAR_POPUP_MOUSE_TIMEOUT_LONG = 250
// should be more than show timeouts to avoid blinks
export const HIDE_SIDEBAR_POPUP_MOUSE_LEFT_TIMEOUT = 300
